(function () {
    'use strict';
    // Directives related to global layout directives
    // Currently: search bar, error bar, modal configuration

    angular.module('GorillaBoy.directives')
    .directive('errorBar', [function () {
        return {
            restrict: 'E',
            controller: ['$rootScope', 'MessageManager', '$scope', 'AppConstants', 'SignalProvider',
            function ($rootScope, MessageManager, $scope, AppConstants, SignalProvider) {
                var errorTypes = AppConstants.ErrorTypes;

                MessageManager.resetAllMessages();

                $rootScope.messageTextClicked = function(message, $event) {
                    if (message.defered) {
                        message.defered.resolve($event);
                    }
                };

                $rootScope.removeMessage = function (index) {
                    MessageManager.removeMessage(index);
                };

                $rootScope.clearAllMessages = function() {
                    var len = $rootScope.messages.Messages.length;
                    for (var i = 0 ; i < len ; i++) {
                        $rootScope.removeMessage(i);
                    }
                };

                $rootScope.getMessageClass = function (type) {
                    switch (type) {
                        case errorTypes.SUCCESS:
                            return 'inner-success';
                        case errorTypes.INFO:
                            return 'inner-info';
                        case errorTypes.IE:
                            return 'inner-ie';
                        default:
                            return 'inner-error';
                    }
                };

                $rootScope.getMessageIcon = function (type) {
                    switch (type) {
                        case errorTypes.SUCCESS:
                            return 'work-docs-icon-checked-round-ffffff-24x24';
                        case errorTypes.INFO:
                            return 'icon-SVG_info';
                        default:
                            return 'work-docs-icon-close-alternate-ffffff-24x24';
                    }
                };

                $rootScope.getFavicon =  function(){
                    if(!$scope.favicon){
                      $scope.favicon = "images/favicon.ico";
                    }
                    return $scope.favicon;
                };


                $scope.escapeHTML = $rootScope.escapeHTML;

                $scope.escapeHTMLIfNotIEMessage = function(type, text) {
                    if (type === errorTypes.IE) {
                        return text;
                    } else {
                        return $scope.escapeHTML(text);
                    }
                };

                $scope.hideSearchMenu = function(){
                    $rootScope.$broadcast(SignalProvider.Search.HideSearchMenu);
                };

            }],
            template:
            '<div class="messages_container sidebar-transition" ng-style="messages.Offset">' +
                '<ul style="margin: 0">' +
                    '<li ng-repeat="message in messages.Messages" uib-collapse="message.closed" class="message" ng-click="messageTextClicked(message, $event)">' +
                        '<div class="inner" ng-class="getMessageClass(message.type)"> '+
                            '<div class="close-icon" ng-click="removeMessage($index)"></div>' +
                            '<div class="errorbar-message-icon" ng-class="getMessageIcon(message.type)"></div>' +
                            '<span class="error-bar-msg-text" ng-bind="escapeHTMLIfNotIEMessage(message.type, message.message)"></span>' +
                        '</div>' +
                    '</li>' +
                '</ul>' +
            '</div>'
        };
    }])
    .directive('sortOrderCaret', [function () {
        // Used in list views to trigger
        return {
            restrict: 'E',
            scope: {
                order: '=',
                show: '=',
                activated: '<'
            },
            link: function(scope, element, attr) {

            },
            template:
                '<div ng-if="show" class="marginleft" ng-class="{\'caret-activated-style\': activated, \'caret-style\': !activated, \'icon-SVG_carat-up\': order, \'icon-SVG_carat-down\': !order}"></div>'
        };
    }])
    .directive('thumbnail', ['SourceConstant', function (SourceConstant) {
        return {
            restrict: 'E',
            link: function (scope, element, attrs) {
                // Move to Global
                scope.DEFAULT_PROFILE_ICON = 'images/default.png';

                if (!scope.src) {
                    scope.src = scope.DEFAULT_PROFILE_ICON;
                }
            },
            scope: {
                // TODO: Add an alt accessibility scope variable to make this image accessible / devices
                src: '=',
                large: '='
            },
            template:
            // Note on comparison: Use manual comparison of large to large so angular handles null or undefined cases nicely.
            '<img ng-class="{false:\'person-thumbnail\', true:\'person-thumbnail person-thumbnail-large\'}[large==\'LARGE\']" ng-src="{{src}}" error-src="{{DEFAULT_PROFILE_ICON}}" ng-cloak/>'
        };
    }]);
}());
